import React from 'react';
import './styles.scss';

// Images
import page1Img from '../../../assets/images/welcomepages/Page1/pg1.png';
import profileImg from '../../../assets/images/welcomepages/Page1/profileImg.png';
import ratingImg from '../../../assets/images/welcomepages/Page1/ratingImg.png';
import shareImg from '../../../assets/images/welcomepages/Page1/sharingImg.png';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/Button/Button';

function Page1() {
    const navigate = useNavigate();
    const goToPage2 = () => {
        navigate('/welcome/2');
    };

    return (
        <div className='page1-cont'>
              <div className="right">
                <h1 className='section-heading'>
                It's easy to get started with Aerial Borne.
                </h1>
                {/* <h3 className='section-sub-heading'>
                    Ready to join AerialBorne Community?
                </h3> */}
                {/* <h4 className='step-heading'>Here is a step by step guide:</h4> */}

                <ul className='list'>
                    <li className='list-item'>
                        <div className="list-icon">
                            <img src={profileImg} alt="" />
                        </div>
                        <div className="list-data">
                            <h4 className='list-heading'>
                            Learn what makes a successful profile:
                            </h4>
                            <p>Discover the do's and don'ts to ensure you're always on the right track.</p>
                        </div>
                    </li>

                    <li className='list-item'
                      style={{
                        padding:'30px 0px',
                        borderTop: '2px solid #BDC1CA',
                        borderBottom: '2px solid #BDC1CA',
                      }}>
                        <div className="list-icon">
                            <img src={ratingImg} alt="" />
                        </div>
                        <div className="list-data">
                            <h4 className='list-heading'>Create your seller profile:</h4>
                            <p>Add your profile picture, description, and professional information.</p>
                        </div>
                    </li>

                    <li className='list-item'>
                        <div className="list-icon">
                            <img src={shareImg} alt="" />
                        </div>
                        <div className="list-data">
                            <h4 className='list-heading'>Publish your Gig:</h4>
                            <p>Create a Gig of the service you're offering and start selling instantly.</p>
                        </div>
                    </li>
                </ul>

                <div className="btn-container">
                    <Button
                        label={'Get started'}
                        handleClick={goToPage2}
                        customStyle={{ backgroundColor: '#08742C', color: 'white', padding:"10px 50px",  }}
                    />
                </div>
            </div>
            <div className="left">
                <img src={page1Img} alt="" />
            </div>
          
        </div>
    );
}

export default Page1;
